import { decodeAuthToken } from 'util/decodeAuthToken';
import { authStore } from 'state/store';
import { computedFn } from 'mobx-utils';

export const selectIsHydrated = () => {
    return authStore.isHydrated;
};

export const selectAuthToken = () => {
    return authStore.authToken;
};

export const selectIsAuthorized = () => {
    const authToken = selectAuthToken();

    return Boolean(authToken);
};

export const selectUser = computedFn(() => {
    const authToken = selectAuthToken();

    if (!authToken) {
        return null;
    }

    return decodeAuthToken(authToken);
});

export const selectUserId = () => {
    const user = selectUser();

    return user?.userId;
};

export const selectUserAvatar = () => {
    const user = selectUser();

    return user?.avatar;
};
